// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

const CircleIcon = props => {
  const { letter, ...rest } = props;

  return (
    <svg viewBox="0 0 100 100" {...rest}>
      <circle
        cx="50%"
        cy="50%"
        r="40"
        stroke="#808283"
        strokeWidth="6"
        fill="none"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        fill="#C0C0C0"
        dy=".3em"
        fontSize="50"
        strokeWidth="4"
      >
        {letter}
      </text>
    </svg>
  );
};

export const Question = (props: IconProps) => (
  <CircleIcon letter="Q" {...props} />
);
export const Answer = (props: IconProps) => (
  <CircleIcon letter="A" {...props} />
);



// WEBPACK FOOTER //
// ./src/components/Icons/QA.js